module.exports = __webpack_public_path__ + "media/images/pic/saska/saska_news-0a82872d1f4e7ee99df37295ef86bb34.svg";